import '../fesd/fesd'
import '../../sass/other/recruiting.sass'
import { _dropdown } from '../includes/_dropdown.js'

$(function() {
  _dropdown.all();
});